<div id="optionsCalculatorForm">
  <ngx-spinner
    [fullScreen]="false"
    bdColor="rgba(51,51,51,0.1)"
    bdOpacity=0.5
    color="#fff"
    name=optionCalculatorSpinner
    size="medium"
    type="ball-spin-clockwise"
  >
    <p style="color: white"></p>
  </ngx-spinner>

  <iv-live-common-calculator [ngStyle]="{'filter' : isLoading ? 'blur(10px)' : null}"
    (changeInstrument)="changeInstrument($event);inputHandler($event);"
    (goButtonClicked)="onGoButtonClick($event)" (hideSpinnerEvent)="hideSpinner()"
    (keyDownSearch)="keyDownSearch()" (modeClicked)="onModeChanged($event)"
    (returnRegionEvent)="returnRegion($event)" (showSpinnerEvent)="showSpinner()"
    [autocompletePlaceholder]="'Stock, Index or Option Symbol...'" [instruments]="instruments" [regionId]="regionId" [stockSearchCriteria]="instrument?.stockid || instrument?.stockId || stockId"
    [stockName]="instrument?.nameAndExchange || instrument?.stockName || instrument?.stockId"
    [value]="instrument?.value">


    <form (ngSubmit)="calculate()" [formGroup]="calculatorForm" class="calculator-wrapper">
      <div class="calculator-body">
        <div class="parameters">
          <!-- Заглушка, которая занимает место для search (вынужденное решение в связи с предыдущей реализацией) -->
          <div class="param" style="opacity:0; visibility: hidden;">
            <span class="param-label"></span>
            <span class="param-value"></span>
          </div>
          <div class="param">
            <span class="param-label with-tip">
              Style
              <span class="tip">An option's style can be American (Amer), European (Euro), or exotic.
              Euro options can only be exercised on the expiration,
              whereas Amer options can be exercised at any point before expiration</span>
            </span>
            <iv-live-dropdown (closeOtherDropdown)="openDropdown(0)" (selectedDataChange)="selectStyle($event)"
              [(selectedData)]="styleName" [cssClass]="'param-value param-value-style'"
              [data]="getArrayFromObject(styles)" [label]="" [valueAttribute]="'name'" data-id="style"
            >
            </iv-live-dropdown>

          </div>

          <div class="param">
            <div class="param-label with-tip">Last Price
              <span class="tip">Stock Last Price/Index Value</span>
            </div>
            <input
              (input)="onlyNumbersPaste($event)"
              (keydown)="keyDown($event)"
              [(ngModel)]="price"
              (ngModelChange)="inputHandler($event)"
              [ngModelOptions]="{standalone: true}"
              class="param-value"
              data-id="price"
            >
          </div>

          <div class="param">
            <div class="param-label with-tip">
              <div>Strike</div>
              <span class="tip">Strike price is the stated price per share for which the underlying stock may
              be purchased (in the case of a call) or sold (in the case of a put)
              by the option holder upon exercise of the option</span>
            </div>
            <input
              (input)="onlyNumbersPaste($event)"
              (keydown)="keyDown($event)"
              [(ngModel)]="priceStrike"
              (ngModelChange)="inputHandler($event)"
              [ngModelOptions]="{standalone: true}"
              class="param-value"
              data-id="stike"
            >
          </div>

          <div class="param">
            <div class="param-label with-tip">
              <div>Expiry</div>
              <span class="tip">Option expiry; closest expiry set by default</span>
            </div>
            <div style="display: flex;gap: 8px">
              <div style="width: 180px">
                <iv-live-dropdown (closeOtherDropdown)="openDropdown(1)" (scroll)="onScroll($event)"
                  (selectedDataChange)="selectExpiration($event)" [cssClass]="'param-value param-value-style'"
                  [data]="getArrayFromObject(expirations)" [label]="" [selectedData]="expDate" [type]="getTypeDropDown()"
                  [valueAttribute]="'expDate'" data-id="expirations">
                </iv-live-dropdown>
              </div>

              <div style="width: 64px">
                <input class="param-value expiry-hours-value" data-id="hours" readonly value="{{getHours()}}">
              </div>

            </div>
          </div>

          <div class="param">
            <span class="param-label with-tip">
              <div>Time to expiration</div>
              <span class="tip">Days, hours, minutes remaining to expiry; you can change this to analyze a nonstandard option or perform what-if analysis</span>
            </span>
            <div class="time-values">
              <input (input)="onExpValueInput($event, 'daysToExp')" (keydown)="keyDown($event)"
                class="param-value" data-id="daysToExp" value="{{daysToExp}}" placeholder="D-">
              <input (input)="onExpValueInput($event, 'hours')" (keydown)="keyDown($event)"
                class="param-value" data-id="hoursToExp" value="{{hours}}" placeholder="H-">
              <input (input)="onExpValueInput($event, 'minutes')" (keydown)="keyDown($event)"
                class="param-value" data-id="minToExp" value="{{minutes}}" placeholder="Min-">
            </div>
          </div>

          <div class="param">
            <div class="param-label with-tip">
              <div>IV</div>
              <span class="tip">Implied Volatility is the market's estimate of future volatility.
              In simple terms, it is derived from the options' bid/ask data</span>
            </div>
            <input (input)="onlyNumbersPaste($event)" (keydown)="keyDown($event)"
              [(ngModel)]="Vola" (ngModelChange)="inputHandler($event)" [ngModelOptions]="{standalone: true}" class="param-value"
              data-id="vola">
          </div>
          <div class="param">
            <div class="param-label with-tip">
              <div>Interest Rate</div>
              <span class="tip">The interest rate used is derived from last night's treasury market and is
              interpolated to conform to option's expiration term.
              We take OIS SOFR for terms up to one year inclusive and ISDA (R)
              Swaps IR par mid rate for terms above one year</span>
            </div>
            <input (input)="onlyNumbersPaste($event)" (keydown)="keyDown($event)"
              [(ngModel)]="rate" (ngModelChange)="inputHandler($event)" [ngModelOptions]="{standalone: true}" class="param-value" data-id="vola">
          </div>

          <ng-container *ngIf="stockType === 'S' || stockType === 'F' || stockType === 'A'">
            <div class="param">
              <span class="param-label with-tip">
                <div>Dividend Date</div>
                <span class="tip">Dividend Date. Stock/ETF's nearest prior announced dividend date</span>
              </span>
              <input (input)="dateValidate($event)" (keydown)="keyDown($event)"
                [(ngModel)]="lastDividendDate" (ngModelChange)="inputHandler($event)" [ngModelOptions]="{standalone: true}" [textMask]="{mask: dateMask}"
                class="param-value" data-id="lastDividendDate" name="date" placeholder="YYYY-MM-DD" type="text"
                value="{{lastDividendDate}}">
            </div>
          </ng-container>

          <ng-container *ngIf="stockType === 'S' || stockType === 'F' || stockType === 'A'">
            <div class="param">
              <span class="param-label with-tip">
                <div>Dividend Amount</div>
                <span class="tip">Dividend Amount. Stock/ETF's dividend amount</span>
              </span>
              <input (input)="onlyNumbersPaste($event)" (keydown)="keyDown($event)"
                [(ngModel)]="lastDividendAmount" (ngModelChange)="inputHandler($event)" [ngModelOptions]="{standalone: true}" class="param-value"
                data-id="lastDividendAmount">
            </div>
          </ng-container>

          <ng-container *ngIf="stockType === 'S' || stockType === 'F' || stockType === 'A'">
            <div class="param">
              <span class="param-label with-tip">
                <div>DivFreq</div>
                <span class="tip">Dividend Frequency. Stock dividend frequency</span>
              </span>
              <iv-live-dropdown
                (closeOtherDropdown)="openDropdown(2)"
                (selectedDataChange)="selectFrequency($event)"
                [(selectedData)]="dividendFrequencyName"
                [cssClass]="'param-value param-value-style'"
                [data]="getArrayFromObject(dividendFrequencies)"
                [label]=" "
                [valueAttribute]="'name'"
                [dropdownOffset]="{'top': 'auto', 'bottom': '36px'}"
                data-id="dividendFrequencyName">
              </iv-live-dropdown>
            </div>
          </ng-container>


          <ng-container *ngIf="stockType === 'I' || stockType === 'X' || stockType === 'A'">
            <div class="param">
              <span class="param-label with-tip" style="align-items: center ">
                <div>Dividend Yield</div>
                <span class="tip">Dividend yield for indices</span>
              </span>
              <input (input)="onlyNumbersPaste($event)" (keydown)="keyDown($event)"
                [(ngModel)]="_yield" [ngModelOptions]="{standalone: true}" class="param-value" data-id="yield">
            </div>
          </ng-container>

        </div>

        <div class="calculator-result">
          <div class="calculator-result-row" style="margin-bottom:-16px">
            <span></span>
            <span class="calculator-result-type result-type-with-border">Call</span>
            <span class="calculator-result-type">Put</span>
          </div>

          <div class="calculator-result-row">
            <a class="with-tip" href="/jargon/" target="_blank">Symbol
              <span class="tip">Shows the option symbols corresponding to inputted expiry and strike</span>
            </a>
            <span (click)="showMessage()" [cbContent]="seriesCall" class="with-tip result-value" statistic
                  statisticElementName="Click show message series call" data-id="seriesCall" ngxClipboard
              style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; cursor: pointer"
            >{{result?.seriesCall}}
              <span class="tip">{{result?.seriesCall}}</span>
            </span>

            <span (click)="showMessage()" [cbContent]="seriesPut" class="with-tip result-value" statistic
                  statisticElementName="Click show message series call" data-id="seriesPut" ngxClipboard
              style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; cursor: pointer "
            >{{(result?.seriesPut)}}
              <span class="tip">{{result?.seriesPut}}</span>
            </span>
          </div>

          <div class="calculator-result-row">
            <span class="with-tip">Option Value<span class="tip">The Option Value calculated by IVolatility calculation
              engine</span></span>
            <span class="result-value" data-id="optValue">{{result?.optValue| number:'1.4'}}</span>
            <span class="result-value" data-id="optValuePut">{{result?.optValuePut| number:'1.4'}}</span>
          </div>

          <div class="calculator-result-row">
            <span class="with-tip">Bid/Ask
              <span class="tip">Bid is a highest price the buyer will pay for an instrument.
                Ask is a lowest price at which the seller will sell an instrument.</span>
            </span>
            <span data-id="askCall" style="font-weight:normal; font-size: 12px; white-space: normal">
              <ng-container *ngIf="result.bidCall != null || result.askCall != null">
                {{result?.bidCall| number:'1.0-2'}}/ {{result?.askCall| number:'1.0-2'}}
              </ng-container>
            </span>
            <span data-id="askPut" style="font-weight:normal; font-size: 12px; white-space: normal">
              <ng-container *ngIf="result.bidCall != null || result.askCall != null" ng-container>
                {{result?.bidPut| number:'1.0-2'}}/ {{result?.askPut| number:'1.0-2'}}
              </ng-container>
            </span>
          </div>

          <div class="calculator-result-row">
            <span class="with-tip">Delta<span class="tip">Delta. (Greek) Change of an option's price relative to a $1 change
              in the underlying's price</span></span>
            <ng-container *ngIf="loading == false">
              <span class="result-value" data-id="deltaCall">{{result?.deltaCall| number:'1.4'}}</span>
              <span class="result-value" data-id="deltaPut">{{result?.deltaPut| number:'1.4'}}</span>
            </ng-container>
            <ng-container *ngIf="loading == true">
              <div style="grid-column-start: 2; grid-column-end: 4; padding-left: 60px">
                <img src="/src/iv-live/assets/form_loading.gif" />
              </div>
            </ng-container>
          </div>

          <div class="calculator-result-row">
            <span class="with-tip">Gamma
              <span class="tip">Gamma. (Greek) Change of Delta relative to a $1 change in the underlying's
                price</span></span>
            <span class="result-value" data-id="gammaCall">{{result?.gammaCall| number:'1.4'}}</span>
            <span class="result-value" data-id="gammaPut">{{result?.gammaPut| number:'1.4'}}</span>
          </div>

          <div class="calculator-result-row">
            <span class="with-tip">Theta
              <span class="tip">Theta. (Greek) Loss of an option's
                value relative to a one day decrease in time to expiration (time decay)</span>
            </span>
            <span class="result-value" data-id="thetaCall">{{result?.thetaCall| number:'1.4'}}</span>
            <span class="result-value" data-id="thetaPut">{{result?.thetaPut| number:'1.4'}}</span>
          </div>

          <div class="calculator-result-row">
            <span class="with-tip">Alpha
              <span class="tip">Alpha. (Greek) Ratio of Gamma over Theta</span>
            </span>
            <span class="result-value" data-id="alphaCall">{{result?.alphaCall| number:'1.4'}}</span>
            <span class="result-value" data-id="alphaPut">{{result?.alphaPut| number:'1.4'}}</span>
          </div>

          <div class="calculator-result-row">
            <span class="with-tip">Vega<span class="tip">Vega. (Greek) Change of an option's price relative
              to a 1% (absolute) change in its implied volatility</span></span>
            <span class="result-value" data-id="vegaCall">{{result?.vegaCall| number:'1.4'}}</span>
            <span class="result-value" data-id="vegPut">{{result?.vegPut| number:'1.4'}}</span>
          </div>

          <div class="calculator-result-row">
            <span class="with-tip">Rho<span class="tip">Rho. (Greek) Change of an option's price relative to a 1%
              (absolute) change in its interest rate</span></span>
            <span class="result-value" data-id="rhoCall">{{result?.rhoCall| number:'1.4'}}</span>
            <span class="result-value" data-id="rhoPut">{{result?.rhoPut| number:'1.4'}}</span>
          </div>

        </div>
      </div>

      <div class="iv-calculator-form">
        <div class="opt-price">
          <div class="opt-price-label">
            Option Price
          </div>

          <input (input)="onlyNumbersPaste($event)"
            (ngModelChange)="changeOptPrice($event)" [(ngModel)]="optionPrice" [class.isEmpty]="optPriceIsEmpty"
            [ngModelOptions]="{standalone: true}" class="opt-price__input" data-id="optionPrice" />
        </div>

        <div class="calculator-result">
          <div class="calculator-result-row">
            <div class="iv-calculator-result__label">
              Implied Volatility
            </div>

            <!--TODO: Полностью переделать  логику подсказок -->

            <span style="position: relative" [style.visibility]=" ivIsNull ?'hidden' : 'visible' " class="with-tip"
              data-id="calculatedIV">
                {{calculatedIVCall * 100 | number:'1.0-2'}}
              <span style="bottom: 100%; right: 100%" class="tip">
                Implied Volatility is the market's estimate of future volatility.
                In simple terms, it is derived from the options' bid/ask data
              </span>
            </span>
            <span style="position: relative" [style.visibility]=" ivIsNull ?'hidden' : 'visible' " class="with-tip"
              data-id="calculatedIV">
                {{calculatedIVPut * 100 | number:'1.0-2'}}
              <span style="bottom: 100%; right: 100%" class="tip">
                Implied Volatility is the market's estimate of future volatility.
                In simple terms, it is derived from the options' bid/ask data
              </span>
            </span>
          </div>
        </div>


      </div>
    </form>
  </iv-live-common-calculator>

</div>
